module.exports = __webpack_public_path__ + "static/media/rovan shot 03.85457dbc.webp";